<template>
  <Fragment>
    <template v-if="currentStep">
      <div class="row mt-4 mt-md-5">
        <div class="col text-center">
          <h1 class="font-main font-weight-bold roi-heading">
            <span v-show="hasIcon">
              <img
                :src="currentStep.imagePath"
                :alt="currentStep.displayName"
              />
            </span>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="currentStep.displayName"></span>
          </h1>
        </div>
      </div>
    </template>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

import { mapGetters } from '../store';

export default {
  name: 'StepHeading',

  components: { Fragment },

  props: {
    hasIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  computed: {
    ...mapGetters(['currentStep']),
  },
};

/**
 * @typedef {import('../store/state').Step} Step
 */
</script>
